import { LEVER_MATCH_EXPIRATION_ENABLED } from 'Lib/ConfigService/levers';
import { ArraySchema, EntitySchema } from 'Lib/schemas';
import { getLeverValue } from 'Lib/utils/getLeverValue';

import { MATCHES_ENTITY_KEY } from 'Store/entities/entityKeys';
import { messageArray } from 'Store/entities/messages.schema';
import { profileEntity } from 'Store/entities/profiles.schema';

/**
 * Match Entity
 * ==============
 */
export const matchEntity = new EntitySchema(
  MATCHES_ENTITY_KEY,
  {
    messages: messageArray,
    person: profileEntity,
  },
  {
    idAttribute: '_id',
    processStrategy(value) {
      // @TODO, is this needed?
      // created_date not always returning from update call,
      // append timestamp

      // Match Expiration: calculate whether match should be
      // archived from entities.matches.archive_at
      let isArchived = false;
      // eslint-disable-next-line @typescript-eslint/naming-convention
      const { archive_at } = value;
      if (getLeverValue(LEVER_MATCH_EXPIRATION_ENABLED) && archive_at) {
        isArchived = archive_at <= Date.now();
      }

      if (value.created_date) {
        return {
          ...value,
          timestamp: Date.parse(value.created_date),
          is_archived_v2: isArchived,
        };
      }
      return value;
    },
  }
);

export const matchArray = new ArraySchema(matchEntity);
